import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getBasketKey } from "../../../utils/basket";
import { generalApiService } from "../../Apis/General";

let initialState = {
  general: null,
  cart: [],
  direct_checkout: null,
  checkout_items: null,
};

export const GeneralSlice = createSlice({
  name: "generalSlice",
  initialState,
  reducers: {
    handleCart: (state, action) => {
      const { item, messages } = action.payload || {};
      if (!item) return;

      const cart = state.cart ? [...state.cart] : [];
      const index = cart.findIndex(
        (entry) => getBasketKey(entry) === getBasketKey(item),
      );

      if (index > -1) {
        cart.splice(index, 1);
        toast.success(messages?.removed || "Item Removed From Cart");
      } else {
        cart.push({
          ...item,
          cartAddedAt: new Date().toISOString(),
        });
        toast.success(messages?.added || "Item Added To Cart");
      }

      state.cart = cart;
    },
    resetCart: (state, action) => {
      state.cart = [];
      state.direct_checkout = null;
      state.checkout_items = null;
    },
    removePurchasedCartItems: (state, action) => {
      const keys = action.payload || [];
      state.cart = state.cart.filter(
        (item) => !keys.includes(getBasketKey(item)),
      );
    },
    setCheckoutItems: (state, action) => {
      state.checkout_items = action.payload;
      state.direct_checkout = null;
    },
    completeCartCheckout: (state) => {
      const items = state.direct_checkout
        ? [state.direct_checkout]
        : state.checkout_items || [];
      const keys = items.map(getBasketKey);
      state.cart = state.cart.filter(
        (item) => !keys.includes(getBasketKey(item)),
      );
      state.checkout_items = null;
      state.direct_checkout = null;
    },
    handleDirectCheckout: (state, action) => {
      if (action?.payload) {
        state.direct_checkout = action?.payload;
        state.checkout_items = null;
      }
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      generalApiService.endpoints.getData.matchFulfilled,
      (state, action) => {
        let { success, data } = action?.payload;
        if (success) {
          state.general = data;
        }
      },
    );
  },
});

export const {
  handleCart,
  resetCart,
  handleDirectCheckout,
  removePurchasedCartItems,
  setCheckoutItems,
  completeCartCheckout,
} = GeneralSlice.actions;
export default GeneralSlice.reducer;
